<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>콘텐츠 통계</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">통계관리</a>
        </li>
        <li class="breadcrumb-item active">콘텐츠통계</li>
      </ol>
    </div>
    <!-- 검색  -->
      <div class="card-body" style="background-color:#fff;">
          <b-card no-body>
              <b-tabs v-model="tabIndex" card >
                  <b-tab title="교과서 콘텐츠 통계" active>
                      <b-card-text>
<!--                            <div class="card card-default" v-show="data.params.mob-tabsde=='list'">-->
                              <div class="card-body">
                                  <!--          임시-->
                                <div class="form-row align-items-center">
                                  <div class="form-group align-items-center row mr-3">
                                    <div class="col-auto">
                                      <label class="col-form-label">채널</label>
                                    </div>
                                    <div class="col-auto">
                                      <input type="checkbox" class="ml-3" v-model="UseYn.teacher" true-value="yes" false-value="no" >
                                      <label class="form-check-label ml-2">교사</label>
                                      <input type="checkbox" class="ml-3" v-model="UseYn.turtor" true-value="yes" false-value="no" >
                                      <label class="form-check-label ml-2">강사</label>
                                    </div>
                                  </div>
                                  <!-- 기간검색 -->
                                  <SchDateRange label="조회기간" :data="data" @search="search" @reset="reset" />
                                </div>
                                <div class="form-row align-items-center">
                                  <!-- <div class="col-auto"> -->
                                      <!-- 학교급 -->
                                      <LabelSelect label="학교급" :opt="schoolGradeOpts" :value="schoolGradeValue"
                                        v-on:changeItem="onchangeSchoolGrade" />
                                      <!-- 학년 -->
                                      <LabelSelect label="학년" :opt="schoolYearOpts" :value="schoolYearValue"
                                        v-on:changeItem="onchangeSchoolYear" />
                                      <!-- 과목 -->
                                      <LabelSelect label="과목" :opt="subjectOpts" :value="subjectValue"
                                        v-on:changeItem="onchangeSubject" />

                                      <!-- 항목 검색 -->
                                      <b-button-group class="ml-4">
                                        <button @click="search()" class="btn btn-primary mb-2"><i class="fa fa-search"></i>Search</button>
                                      </b-button-group>
                                  <!-- </div> -->
                                </div>
                              </div>
<!--                            </div>-->
                      </b-card-text>
                  </b-tab>
                  <b-tab title="참고서 콘텐츠 통계">
                      <b-card-text>
<!--                            <div class="card card-default" v-show="data.params.mob-tabsde=='list'">-->
                              <div class="card-body">
                                  <!--          임시-->
                                <div class="form-row align-items-center">
                                  <div class="form-group align-items-center row mr-3">
                                    <div class="col-auto">
                                      <label class="col-form-label">채널</label>
                                    </div>
                                    <div class="col-auto">
                                      <input type="checkbox" class="ml-3" v-model="UseYn.teacher" true-value="yes" false-value="no" >
                                      <label class="form-check-label ml-2">교사</label>
                                      <input type="checkbox" class="ml-3" v-model="UseYn.turtor" true-value="yes" false-value="no" >
                                      <label class="form-check-label ml-2">강사</label>
                                    </div>
                                  </div>
                                  <!-- 기간검색 -->
                                  <SchDateRange label="조회기간" :data="data" @search="search" @reset="reset" />
                                </div>
                                <div class="form-row align-items-center">
                                  <!-- <div class="col-auto"> -->
                                      <!-- 학교급 -->
                                      <LabelSelect label="학교급" :opt="schoolGradeOpts" :value="schoolGradeValue"
                                        v-on:changeItem="onchangeSchoolGrade" />
                                      <!-- 학년 -->
                                      <LabelSelect label="학년" :opt="schoolYearOpts" :value="schoolYearValue"
                                        v-on:changeItem="onchangeSchoolYear" />
                                      <!-- 과목 -->
                                      <LabelSelect label="과목" :opt="subjectOpts" :value="subjectValue"
                                        v-on:changeItem="onchangeSubject" />

                                      <!-- 항목 검색 -->
                                      <b-button-group class="ml-4">
                                        <button @click="search()" class="btn btn-primary mb-2"><i class="fa fa-search"></i>Search</button>
                                      </b-button-group>
                                  <!-- </div> -->
                                </div>
                              </div>
<!--                            </div>-->
                      </b-card-text>
                  </b-tab>
                  <b-tab title="맞춤 콘텐츠 통계">
                      <b-card-text>준비 중 입니다.</b-card-text>
                  </b-tab>
                  <b-tab title="맞춤 강좌 통계">
                      <b-card-text>준비 중 입니다.</b-card-text>
                  </b-tab>
                  <b-tab title="이슈톡 콘텐츠 통계">
                      <b-card-text>준비 중 입니다.</b-card-text>
                  </b-tab>
                  <b-tab title="프리톡 콘텐츠 통계">
                      <b-card-text>준비 중 입니다.</b-card-text>
                  </b-tab>
              </b-tabs>
          </b-card>
      </div>
    <!-- // 검색 -->

    <!-- 목록: tab 0 -->
    <div v-show="data.params.mode=='list'&&tabIndex===0" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">교과서 채택 순위</span>
        <div class="card-tool float-right" >
<!--          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="saveDetail()" >등록</b-btn>-->
            <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="excelDownload()" >엑셀 다운로드</b-btn>
        </div>
        <ShowCounter label="Show" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center" @click="dataAction.sort(search,'seq')">No<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'update_date')">일자<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'school_category_nm')">학교급<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'school_year')">학년<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'subject_nm')">과목<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'textbook_nm')">교제명<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'adopt_cnt')">채택 수<em class="fa-2s mr-2 fas fa-sort"></em></td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
          <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"  > <!--  @click.prevent="edit(item.seq);" -->
            <td class="align-middle text-center">{{item.seq}}</td>
            <td class="align-middle text-center">{{item.updateDate}}</td>
            <td class="align-middle text-center">{{item.schoolCategoryNm}}</td>
            <td class="align-middle text-center">{{item.schoolYear}}</td>
            <td class="align-middle text-center">{{item.subjectNm}}</td>
            <td class="align-middle text-center">{{item.textbookNm}}</td>
            <td class="align-middle text-center">{{item.adoptCnt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- 목록: tab 1 -->
    <div v-show="data.params.mode=='list'&&tabIndex===1" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">참고서 채택 순위</span>
        <div class="card-tool float-right" >
<!--          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="saveDetail()" >등록</b-btn>-->
            <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="excelDownload()" >엑셀 다운로드</b-btn>
        </div>
        <ShowCounter label="Show" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center" @click="dataAction.sort(search,'seq')">No<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'update_date')">일자<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'cate_cd_nm')">카테고리 1<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'subject_nm')">카테고리 2<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'textbook_nm')">참고서명<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="dataAction.sort(search,'adopt_cnt')">채택 수<em class="fa-2s mr-2 fas fa-sort"></em></td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
          <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"  > <!--  @click.prevent="edit(item.seq);" -->
            <td class="align-middle text-center">{{item.seq}}</td>
            <td class="align-middle text-center">{{item.updateDate}}</td>
            <td class="align-middle text-center">{{item.cateCdNm}}</td>
            <td class="align-middle text-center">{{item.subjectNm}}</td>
            <td class="align-middle text-center">{{item.textbookNm}}</td>
            <td class="align-middle text-center">{{item.adoptCnt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 끝 -->

  </ContentWrapper>
</template>
<script>
import { onMounted, reactive, ref, computed, watch } from '@vue/composition-api';
import {dataObject} from '@/utils/Constants';
import {getTextbookAdoptList} from "@/api/stats/TextbookAdoptApi"
import Pagenation from '@/components/Common/Pagenation'
import SchDateRange from '../../components/Common/SchDateRange'
import ShowCounter from '../../components/Common/ShowCounter'
import LabelSelect from '../../components/Common/LabelSelect'
import { TableActionClass } from '@/utils/TableActionClass';
import store from "@/store/index";

export default {
  components: {SchDateRange, ShowCounter, Pagenation, LabelSelect},

  setup() {
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject);

    let tabIndex = ref(0);
    watch(tabIndex, (tabIndex, prevIndex) => {
      console.log('tabIndex='+tabIndex);
      if (tabIndex === 0 || tabIndex === 1) {
        search();
      } else {
        data.list=[];
      }
    });

    let UseYn = reactive({
      teacher : 'yes',
      turtor: 'yes',
    });
    // 학교급
    const schoolGradeOpts = computed(() =>store.state.StatFilter.schoolGradeOpts);
    const schoolGradeValue = computed(() =>store.state.StatFilter.schoolGradeValue);
    const onchangeSchoolGrade = (value) => { store.dispatch('StatFilter/onchangeSchoolGrade', value) }
    // 학년
    const schoolYearOpts = computed(() =>store.state.StatFilter.schoolYearOpts);
    const schoolYearValue = computed(() =>store.state.StatFilter.schoolYearValue);
    const onchangeSchoolYear = (value) => { store.dispatch('StatFilter/onchangeSchoolYear', value) }
    // 과목
    const subjectOpts = computed(() =>store.state.StatFilter.subjectOpts);
    const subjectValue = computed(() =>store.state.StatFilter.subjectValue);
    const onchangeSubject = (value) => { store.dispatch('StatFilter/onchangeSubjectNoText', value) }

    /////////////////
    const loadData = () => { store.dispatch('StatFilter/resetFilter') }

    const fileRemove = () =>{
      data.row.url = null;
    }

    const search = () => {
      var context = {};
      context['getTextbookAdoptList'] = getTextbookAdoptList;

      let useChannel = '';
      if (UseYn.teacher==='yes') useChannel += '105002;';
      if (UseYn.turtor==='yes') useChannel += '105003;';
      // if (UseYn.student==='yes') useChannel += '105005;';
      
      data.params.schUseChannel = useChannel;

      if (tabIndex.value === 0) data.params.schBookTypeCd = '330001';
      else if (tabIndex.value === 1) data.params.schBookTypeCd = '330002';
      else data.params.schBookTypeCd = '';

      data.params.schSchoolGradeCd = schoolGradeValue.value;
      data.params.schSchoolYear = schoolYearValue.value;
      data.params.schSubjectCd = subjectValue.value;
      data.params.schTextbookId = '';
      let _params = data.params;
      
      dataAction.execute("getTextbookAdoptList",context,_params)
          .then(({ data }) => fileRemove())
          .catch((error) => console.error(error));
    }

    const reset = () => {
      data.params.mode = "list";
    }

    const dataAction = new TableActionClass(data);

    onMounted(loadData);

    return{
      dataObject,
      _dataObject,
      data,
      tabIndex,
      UseYn,
      schoolGradeOpts,
      schoolGradeValue,
      schoolYearOpts,
      schoolYearValue,
      subjectOpts,
      subjectValue,
      fileRemove,      
      onchangeSchoolGrade,
      onchangeSchoolYear,
      onchangeSubject,
      // ...methods(),
      search,
      reset,
      dataAction,
    }
  }
}
</script>
